import { API_ENDPOINTS } from '@api/ApiEndpoints';
import useUIStore from '@store/uiStore';
import { UseMutationResult, useMutation } from '@tanstack/react-query';
import { useHttpClient } from '@hooks/utils/httpConfig';
import { Variant } from '@components/ui/Toast';

export const useRoadmapRequestEmailMutation = (): UseMutationResult<boolean, unknown, void> => {
  const { addToast } = useUIStore();
  const roadmapClient = useHttpClient();

  return useMutation({
    mutationFn: () => roadmapClient.post<boolean>(API_ENDPOINTS.ROADMAP_REQUEST_EMAIL, {}),
    onSuccess: () => {
        addToast({
          variant: Variant.Success,
          message: 'Roadmap request sent successfully.',
          closeable: true,
        });
      },
      onError: () => {
        addToast({
          variant: Variant.Error,
          message: 'Failed to send roadmap request. Please try again.',
          closeable: true,
        });
      },
  });
};

export const useRoadmapRequestArrangeCallbackMutation = (): UseMutationResult<
  boolean,
  unknown,
  string | undefined
> => {
  const { addToast } = useUIStore();
  const roadmapClient = useHttpClient();

  return useMutation({
    mutationFn: (notes?: string) =>
      roadmapClient.post<boolean>(
        API_ENDPOINTS.ROADMAP_REQUEST_ARRANGE_CALLBACK_EMAIL,
        notes || ''
      ),
    onSuccess: () => {
        addToast({
          variant: Variant.Success,
          message: 'Callback request sent successfully. We will contact you soon.',
          closeable: true,
        });
      },
      onError: () => {
        addToast({
          variant: Variant.Error,
          message: 'Failed to send callback request. Please try again.',
          closeable: true,
        });
      },
  });
};

// Export the new hook
export * from './useOrganizationRoadmaps';
export * from './useRoadmapQuery';